import { filterWithPaginationStates, useFilterWithPaginationV2 } from 'hooks';
import { DEFAULT_PAGINATION, type FilterWithPaginationStateShape } from 'hooks/useFilterWithPagination';
import type { MeterModelsApiFilter } from 'lib/services';

export type MeterModelsFilterShape = Pick<MeterModelsApiFilter, 'search' | 'sort'> & {
  search?: MeterModelsApiFilter['search'];
  commodity?: MeterModelsApiFilter['commodity'];
};

const STATE_KEY = 'MeterModelsFilterState';

export const DEFAULT_FILTER: MeterModelsFilterShape = {
  search: undefined,
  commodity: undefined,
  sort: {
    name: 'asc',
  },
};

const PAGINATION = {
  ...DEFAULT_PAGINATION,
  sort: {
    name: 'asc',
  },
} as const;

const states = filterWithPaginationStates({
  domainKey: STATE_KEY,
  filterDefaultValue: DEFAULT_FILTER,
  paginationDefaultValue: PAGINATION,
});

export type MeterModelsFilterWithPaginationShape = FilterWithPaginationStateShape<MeterModelsFilterShape>;

export const useMeterModelsFilterWithPagination = (): MeterModelsFilterWithPaginationShape =>
  useFilterWithPaginationV2(states);
